import RouteParent from 'js/router/route-parent';

// Importamos las páginas Pug como componentes Vue
import SuperAdminIndex from 'js/pages/super-admin/index.js';
import SuperAdminNew from 'js/pages/super-admin/new.js';
import SuperAdminEdit from 'js/pages/super-admin/edit.js';
import SuperAdminShow from 'js/pages/super-admin/show.js';
import SuperAdminResetPassword from 'js/pages/super-admin/reset-password-modal.js';

export default [
  {
    path: '/super-admin',
    component: RouteParent,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'super-admin-index',
        component: SuperAdminIndex,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      },
      {
        path: 'new',
        name: 'super-admin-new',
        component: SuperAdminNew,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      },
      {
        path: ':id/edit',
        name: 'super-admin-edit',
        component: SuperAdminEdit,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      },
      {
        path: ':id',
        name: 'super-admin-show',
        component: SuperAdminShow,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      },
      {
        path: ':id/reset-password',
        name: 'super-admin-reset-password',
        component: SuperAdminResetPassword,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      }
    ]
  }
];
